import { useEffect, useRef, useState } from "react";

export function useAutoScroll(dependency) {
  const chatRef = useRef<HTMLDivElement | null>(null);
  const [autoScroll, setAutoScroll] = useState(true);

  // Detect if user scrolls up
  useEffect(() => {
    const chat = chatRef.current;
    if (!chat) return;

    const handleScroll = () => {
      const distanceFromBottom =
        chat.scrollHeight - chat.scrollTop - chat.clientHeight;

      // smaller = more sensitive to user scrolls
      const isAtBottom = distanceFromBottom < 2; // was 50
      setAutoScroll(isAtBottom);
    };

    chat.addEventListener("scroll", handleScroll);
    return () => chat.removeEventListener("scroll", handleScroll);
  }, []);

  // Auto scroll only when user is not reading older messages
  useEffect(() => {
    const chat = chatRef.current;
    if (autoScroll && chat) {
      chat.scrollTop = chat.scrollHeight;
    }
  }, [dependency, autoScroll]);

  return chatRef;
}
